import isProduction from '@/plugins/environment'

export const environment = {
  data () {
    return {
      isProduction
    }
  }
}
